/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMaxSendAmount} from '../api'

 export const useQueryGetMaxSendAmount = createReactQueryHook('getMaxSendAmount', getMaxSendAmount)
